import React from 'react'
import analytics from '@/shared-utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import CarProduct from './CarProduct'
import HotelProduct from './HotelProduct'
import { Listing, CarListing } from './types'

export function fireEventForViewMoreDeals() {
  analytics.fireEvent({
    action: 'Feature Box CTA',
    category: ANALYTICS_CATEGORY_HOME,
    label: 'Cross Sell View More Deals'
  })
}

function isCarListing(listing: Listing): listing is CarListing {
  return (listing as CarListing).carExample !== undefined
}

function renderXSellProduct(listing: Listing, offerToken: string) {
  if (isCarListing(listing)) {
    return <CarProduct {...listing} key={listing.id} />
  }
  return (
    <HotelProduct {...listing} key={listing.hotelId} offerToken={offerToken} />
  )
}

export function renderXSellProducts(
  listings: Listing[],
  offerToken: string,
  numProducts = 2
) {
  return listings
    .slice(0, numProducts)
    .map(listing => renderXSellProduct(listing, offerToken))
}
